import type { PlayerStatus } from '@sorrem/shared';
import styles from './ActiveAffliction.module.scss';

interface ActiveAfflictionProps {
    status: PlayerStatus;
}

/** What each affliction is called, and what it does, for the chip and its hover text. */
const AFFLICTIONS: Readonly<Record<Exclude<PlayerStatus, 'normal'>, { label: string; description: string }>> = {
    burned: { label: 'Burning', description: 'Losing essence each second.' },
    poisoned: { label: 'Poisoned', description: 'Losing essence each second.' },
    slowed: { label: 'Slowed', description: 'Moving more slowly.' },
    stunned: { label: 'Stunned', description: 'Unable to act.' },
};

/**
 * What an enemy has left on the local player (burning, poisoned, slowed), as
 * a chip above the loadout. Renders nothing while they are unafflicted.
 */
export function ActiveAffliction({ status }: ActiveAfflictionProps): JSX.Element | null {
    if (status === 'normal') {
        return null;
    }
    const affliction = AFFLICTIONS[status];
    return (
        <div className={styles.activeAffliction} data-status={status} title={affliction.description} role='status'>
            {affliction.label}
        </div>
    );
}
